import React, { Component } from "react";
import { Jumbotron, ButtonGroup, Button, Media } from "reactstrap";
import emailFormImg from "./Images/lifting.jpg";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exercises: [
        {
        id: 1,
        exercise: "Squats",
        classification: "strength/hypetrophy/conditioning",
        kineticChain: "close bilateral",
        jointAction: "knee flexion/hip flexion/abduction",
        secondaryMovement: "concentric contraction",
        muscles: "quads/hamstrings/glutes",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 2,
        exercise: "Pushup",
        classification: "strength/hypetrophy/conditioning",
        kineticChain: "close bilateral",
        jointAction: "elbow extension/shoulder flexion",
        secondaryMovement: "concentric contraction",
        muscles: "triceps/chest/shoulders",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 3,
        exercise: "pull up",
        classification: "strength/hypertrophy",
        kineticChain: "open bilateral",
        jointAction: "elbow flexion",
        secondaryMovement: "concentric contraction",
        muscles: "lats/biceps/serratus anterior",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 4,
        exercise: "handstand",
        classification: "balance/strength",
        kineticChain: "open bilateral",
        jointAction: "shoulder flexion/external rotation",
        secondaryMovement: "isometric contraction",
        muscles: "deltoids/triceps",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 5,
        exercise: "jumping jacks",
        classification: "conditioning",
        kineticChain: "open bilateral",
        jointAction: "hip abduction/shoulder abduction",
        secondaryMovement: "concentric contraction",
        muscles: "respiratory system",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 6,
        exercise: "straight arm plank",
        classification: "balance/strength",
        kineticChain: "close bilateral",
        jointAction: "shoulder flexion",
        secondaryMovement: "isometric contraction",
        muscles: "abdominals/shoulders",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 7,
        exercise: "dumbbell bicep curl",
        classification: "hypertrophy",
        kineticChain: "close unilateral",
        jointAction: "elbow flexion",
        secondaryMovement: "concentric contraction",
        muscles: "bicep",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 8,
        exercise: "hanging knee raises",
        classification: "strength/hypertrophy/conditioning",
        kineticChain: "open bilateral",
        jointAction: "shoulder flexion/shoulder internal rotation/hip flexion",
        secondaryMovement: "concentric contraction",
        muscles: "rectus abdomens/psoas",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 9,
        exercise: "kettlebell swing",
        classification: "strength/conditioning",
        kineticChain: "close bilateral",
        jointAction: "hip extension",
        secondaryMovement: "concentric contraction",
        muscles: "gluteus/hamstrings",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        },
        {
        id: 10,
        exercise: "Deadlift",
        classification: "strength/hypertrophy",
        kineticChain: "close bilateral",
        jointAction: "hip extension/shoulder extension",
        secondaryMovement: "concentric contraction",
        muscles: "gluteus/hamstrings/lats",
        numOfSets: "sets",
        reps: "reps",
        weight: "weight",
        notes: "notes"
        }],
      goal: "",
      classification: "",
      weight: ""
    };

    this.handleKeyChange = this.handleKeyChange.bind(this);
    this.handleGoalChange = this.handleGoalChange.bind(this);
    this.handleExerciseRender = this.handleExerciseRender.bind(this);
  }

  handleKeyChange(event) {
    console.log("inside func");
    this.setState({ weight: event.target.value }, function() {
      console.log(this.state.weight);
    });
  }

  handleGoalChange(event) {
    console.log("inside goal func");
    this.setState({ goal: event.target.innerHTML }, function() {
      console.log(this.state.goal);
      if(this.state.goal === "Lose") {
        this.setState({classification: "strength/hypertrophy"}, () => {
          console.log(this.state.classification);
          this.handleExerciseRender();
        })
      } else if(this.state.goal === "Maintain") {
        this.setState({classification: "conditioning"}, () => {
          console.log(this.state.classification);
          this.handleExerciseRender();
        })
      } else if(this.state.goal === "Gain") {
        this.setState({classification: "strength/hypertrophy/conditioning"}, () => {
          console.log(this.state.classification);
          this.handleExerciseRender();
        })
      }
      // this.handleExerciseRender();
    });
  }

  handleExerciseRender() {
    // console.log(document.getElementsByClassName("eOne")[0].innerHTML);
    // console.log(document.getElementsByClassName("eTwo")[0].innerHTML);
    // console.log(document.getElementsByClassName("eThree")[0].innerHTML);
    let type = this.state.classification;
    let count = 1;
    this.state.exercises.map((exercise) => {
      // console.log(exercise.classification);
      if(exercise.classification.includes(type)) {
        console.log('Inside', exercise);
        if(count === 1) {
          let setXReps = (Math.floor((Math.random() * 3) + 1) + 'x' + Math.floor((Math.random() * 5) + 12));
          document.getElementsByClassName("eOne")[0].innerHTML = exercise.exercise + " " + setXReps;;
          count ++;
        } else if (count === 2) {
          let setXReps = (Math.floor((Math.random() * 3) + 1) + 'x' + Math.floor((Math.random() * 5) + 12));
          document.getElementsByClassName("eTwo")[0].innerHTML = exercise.exercise + " " + setXReps;;
          count ++;
        } else if(count === 3) {
          let setXReps = (Math.floor((Math.random() * 3) + 1) + 'x' + Math.floor((Math.random() * 5) + 12));
          document.getElementsByClassName("eThree")[0].innerHTML = exercise.exercise + " " + setXReps;
          count ++;
        } else {
          return type;
        }
      }
    })
  }

  render() {
    return (
      <div className="home">
        <div className="home-filler">
          <h1>Train outside the box</h1>
        </div>
        <Jumbotron className="mid-section">
          <h1>3D Strength</h1>
          <p>
            We believe in the right to individuality through movement. The
            workout that makes you the happiest is the one that will deliver
            your best results. Rather than dictating static solutions, like most
            fitness apps and workout programs, we believe in guiding the user
            through their fitness journey. Our training programs will seamlessly
            adapt to the users lifestyle while progressively getting more
            challenging and integrating various areas of fitness together.
          </p>
        </Jumbotron>
        <div className="marketing">
          <section className="marketing-message">
            <span className="fas fa-clone circle-yes" />
            <h2>Dynamic</h2>
            <p>
              Our workout building app will learn the user’s interests and
              habits to create unique training programs that will challenge and
              motivate the user while also educating them and keeping track of
              their progress.
            </p>
          </section>
          <section className="marketing-message">
            <span className="fas fa-users" />
            <h2>For Everyone</h2>
            <p>
              We want to deliver automated workouts made with your goals in
              mind. We want fitness to accessible, so you should be able to
              download the app and start right away.
            </p>
          </section>
          <section className="marketing-message">
            <span className="fa fontawesome-icon fa-skyatlas circle-yes" />
            <h2>Education</h2>
            <p>
              At 3DS we provide the option to learn more about the exercises
              that you are doing and why you are doing them if you choose to do
              so.{" "}
            </p>
          </section>
        </div>
        <div className="test-app">
          <h1>Test out our application:</h1>
          <div className="testApp">
            <form className="enterWeight">
              <input
                className="weightField"
                type="text"
                placeholder="Enter a weight"
                onChange={this.handleKeyChange}
              />
            </form>
            <ButtonGroup vertical className="weight">
              <p>Goal: </p>
              <Button className="weightButton" onClick={this.handleGoalChange}>Lose</Button>
              <Button className="weightButton" onClick={this.handleGoalChange}>Maintain</Button>
              <Button className="weightButton" onClick={this.handleGoalChange}>Gain</Button>
            </ButtonGroup>
            <div className="exerciseList">
              <p className="eOne">Push ups <span className="oneSetsXReps">3x10</span></p>
              <p className="eTwo">Pull ups <span className="twoSetsXReps">3x4</span></p>
              <p className="eThree">Jumping Jacks <span className="threeSetsXReps">3x20</span></p>
            </div>
          </div>
          <p className="disclaimer">Please note that this application in still under development, and undergoing changes.</p>
        </div>
        <div className="email-form">
          <Media className="medi">
            <Media left href="#">
              <img src={emailFormImg} alt="Lifting weights" />
            </Media>
            <Media body>
              <Media heading className="email-header">
                Get in contact with us to learn more today.
              </Media>
              <p>Sign up for our beta-testing program.</p>
              <p>
                <a href="https://angelcortez.typeform.com/to/ZbblBX">
                  Fill out our survey to help us learn more about you.
                </a>
              </p>
              <p>e-Mail us at: 3dsdigitalcoach@gmail.com</p>
              <p>Call us at: 347-666-0555</p>
            </Media>
          </Media>
        </div>
        <footer>Made at 3dStrength</footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Home.jsx